module.exports = __webpack_public_path__ + "static/media/report.616e2e0c.svg";